import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import { sendGetRequest } from '../services/PDService';
import * as Sentry from '@sentry/browser';

export const getEvaluations = createAsyncThunk(
  'evaluations/getEvaluations',
  async (payload, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await sendGetRequest(
        `virtual-humans/${payload}/evaluations`,
        getState().virtualHuman.data.ShareToken
      );
      return response.data.evaluations;
    } catch (err) {
      Sentry.captureException(err);
      return rejectWithValue(err.response.data);
    }
  }
);

const EvaluationSlice = createSlice({
  name: 'action',
  initialState: {
    status: 'idle',
    evaluations: null,
    error: '',
  },
  reducers: {
    resetEvaluations: (state, action) => {
      state.evaluations = null;
    },
  },
  extraReducers: {
    [getEvaluations.pending]: (state, action) => {
      state.status = 'pending';
    },
    [getEvaluations.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.evaluations = action.payload;
    },
    [getEvaluations.rejected]: (state, action) => {
      state.status = 'rejected';
      state.error = 'Failed to connect.';
    },
  },
});

export const { resetEvaluations } = EvaluationSlice.actions;

export const evaluationsSelector = (state) =>
  state.evaluation.evaluations ?? [];

export default EvaluationSlice;
